import script from "./BillableConversationsTrendChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./BillableConversationsTrendChart.vue?vue&type=script&lang=ts&setup=true"

import "./BillableConversationsTrendChart.vue?vue&type=style&index=0&id=efbbefd6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efbbefd6"]])

export default __exports__